import {styled} from '@mui/material/styles'
import Button from '@mui/material/Button'

const ButtonStyled = styled(Button)(({theme}) => ({
  button: {
    textTransform: 'capitalize',
    color: theme.palette.primary.dark,
    '&:hover': {
      color: theme.palette.primary.main,
    },
  },
}))

const Trigger = ({children, ...rest}) => {
  return <ButtonStyled {...rest}>{children}</ButtonStyled>
}

export default Trigger
